import { render } from "./AjusteInventario.vue?vue&type=template&id=b7e62902&scoped=true"
import script from "./AjusteInventario.vue?vue&type=script&lang=js"
export * from "./AjusteInventario.vue?vue&type=script&lang=js"

import "./AjusteInventario.vue?vue&type=style&index=0&id=b7e62902&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7e62902"]])

export default __exports__